import { Textarea } from '@/components/ui/textarea';
import { RaffleAdminConfig } from '@/generated/graphql';
import { configChanged } from '@/providers/AdminEngagementProvider/actions';
import { useAdminEngagementContext } from '@/providers/AdminEngagementProvider/AdminEngagementContext';
import { cn } from '@/lib/utils';
import { DEFAULT_RAFFLE_CLAIM_COPY } from '../drawing/ticketMotion';

export function ClaimYourPrizeInput({
  className,
  id,
}: {
  className?: string;
  id?: string;
}) {
  const { state, dispatch } = useAdminEngagementContext();
  const value =
    (state.config as RaffleAdminConfig | null)?.claimYourPrize ?? '';

  return (
    <Textarea
      id={id}
      data-name="RAFFLE_CLAIM_MESSAGE"
      rows={2}
      value={String(value)}
      placeholder={DEFAULT_RAFFLE_CLAIM_COPY}
      className={cn('min-h-[4.5rem] resize-y', className)}
      onChange={(e) => {
        dispatch(configChanged({ config: { claimYourPrize: e.target.value } }));
      }}
    />
  );
}
